import api from "@/api/axios.js";

// Logica condivisa da FlyerPreprocessPage e VariantPreprocessPage per la modale dei campi
// manuali aperta col tasto destro sulle gabbie.

const isEmptyManualValue = (value) =>
	value === null || value === undefined || value === "" || (Array.isArray(value) && !value.length);

// Valore iniziale di ciascun campo: precompilato solo se tutte le gabbie bersaglio hanno lo
// stesso valore, altrimenti undefined (la riga appare vuota e, se non toccata, non viene inviata).
export function collectSharedInitialValues(fieldList, targetIds, readValue)
{
	const initialValues = {};
	for (const field of fieldList)
	{
		const values = targetIds.map((id) => readValue(id, field.key));
		const first = values[0];
		const allSame = values.every((v) => JSON.stringify(v ?? null) === JSON.stringify(first ?? null));
		initialValues[field.key] = allSame ? first : undefined;
	}
	return initialValues;
}

// Sulle gabbie banner i valori reali stanno sulla card (FlyerCard.banner.*), che l'editor card
// modifica senza riportarli sulla gabbia: la modale va precompilata da lì, altrimenti mostrerebbe
// vuoto un campo già compilato. Mappa seriale → banner della card; vuota se la richiesta fallisce
// (la modale ripiega sui valori salvati sulla gabbia).
export async function fetchBannerValuesBySerial(flyerId)
{
	const map = new Map();
	try
	{
		const {data} = await api.get(`/api/flyers/${flyerId}/cards`);
		for (const card of (Array.isArray(data) ? data : []))
			if (card?.typeGabbia === "banner" && card.seriale != null)
				map.set(Number(card.seriale), card.banner || {});
	}
	catch
	{
		// Nessun errore a video: restano i valori della gabbia.
	}
	return map;
}

// Valore di un campo banner per una gabbia: quello della card se la card esiste già (è la fonte
// aggiornata, anche dopo modifiche nell'editor), altrimenti quello impostato sulla gabbia.
export function readBannerZoneValue(zone, bannerBySerial, fieldKey)
{
	const banner = zone ? bannerBySerial.get(Number(zone.id)) : undefined;
	if (banner)
		return isEmptyManualValue(banner[fieldKey]) ? undefined : banner[fieldKey];
	return zone?.manualOverrides ? zone.manualOverrides[fieldKey] : undefined;
}

// Applica alla gabbia (stato locale) i campi effettivamente salvati dal backend, che possono
// includerne di impliciti (es. Banner svuotato quando si compila Banner video). Le etichette
// arrivano dal payload inviato dalla modale.
export function applyManualFieldsToZone(zone, savedFields, labelByKey)
{
	const overrides = {...(zone.manualOverrides || {})};
	const labels = {...(zone.manualLabels || {})};
	for (const {fieldKey, value} of savedFields)
	{
		if (isEmptyManualValue(value))
		{
			delete overrides[fieldKey];
			delete labels[fieldKey];
			continue;
		}
		overrides[fieldKey] = value;
		const label = labelByKey.get(fieldKey);
		if (label)
			labels[fieldKey] = label;
		else
			delete labels[fieldKey];
	}
	return {
		...zone,
		manualOverrides: Object.keys(overrides).length ? overrides : undefined,
		manualLabels: Object.keys(labels).length ? labels : undefined
	};
}
